import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { SaveRequired } from '@base/lm-base';
import { LMHtmlPageComponent } from '@html/lm-html-page.component';
import { LMGlobalUtilService } from './utils';
import { Location } from '@angular/common';
import { LMUrlUtilService } from '@services/utils';
import { Injectable } from '@angular/core';

@Injectable()
export class DeactivateGuard implements CanDeactivate<SaveRequired> {

  constructor(
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmUrlUtilService: LMUrlUtilService,
    private location: Location,
  ) {}

  canDeactivate(component: SaveRequired, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {
    if (component) {
      if (component instanceof LMHtmlPageComponent) {
        const htmlPageComp: LMHtmlPageComponent = <LMHtmlPageComponent>component;
        // if we get here we know the the route is <dataArea>/<webApp>/html/url?

        if (!htmlPageComp.htmlDocComponent) {
          return true;
        }
        const currentUrl: string =  htmlPageComp.htmlDocComponent.getLoadedUrl();
        const possibleNextUrl: string = nextState.url;

        const currentUrlPath: string = currentUrl.indexOf('?') >= 0 ? currentUrl.substring(0, (currentUrl.indexOf('?'))) : currentUrl;
        const possibleNextUrlPath: string = possibleNextUrl.indexOf('?') >= 0 ? possibleNextUrl.substring(0, possibleNextUrl.indexOf('?')) : '';

        const currentUrlParams: string = currentUrl.indexOf('?') >= 0 ? currentUrl.substring((currentUrl.indexOf('?') + 1)) : currentUrl;
        const possibleNextUrlParams: string = possibleNextUrl.indexOf('?') >= 0 ? possibleNextUrl.substring((possibleNextUrl.indexOf('?') + 1)) : '';

        // let htmlPageComp: LMHtmlPageComponent = <LMHtmlPageComponent>component;
        // let oldUrl = htmlPageComp.autoLoadUrl;
        // // let currentRouteUrl = htmlPageComp.getCurrentRouterUrl();
        // let currentHost = window.location.host;
        // let currentProtocol = window.location.protocol;
        // let currentUrl = currentProtocol + '//' + currentHost.toLowerCase() + currentRouteUrl;
        //
        if (currentUrlPath === possibleNextUrlPath) {
          // ok now we know we are going to try to load the LMHtmlPageComponent because the paths match.
          // Also - We dont want to keep firing the same event if the params are the same.

          // only load when params are changed
          let possibleNextUrlParamsArray: Array<string>  = possibleNextUrlParams.split('&');
          possibleNextUrlParamsArray = this.lmUrlUtilService.stripCSKs(possibleNextUrlParamsArray);

          setTimeout(() => {
            htmlPageComp.htmlDocComponent.setLoadedUrl(possibleNextUrl);
            htmlPageComp.htmlDocComponent.fireSameUrlRequested(possibleNextUrl);
          });
          return false;
        }
      }

      return component.allowPageNavigation();
    }
  }
}
